import React, { ReactElement } from "react";
import { Text } from "web/react/emo/text";

export function LabelledRow({
    label,
    value,
}: {
    label: string;
    value: React.ReactNode;
}): ReactElement {
    return (
        <Text as="p" textStyle="body-xs">
            <Text as="span" textStyle="body-xs" color="secondary">
                {`${label}: `}
            </Text>
            <Text as="span" textStyle="body-xs">
                {value}
            </Text>
        </Text>
    );
}
